export const isValidModalSrc = (pModalSrc: string) => {
  const modalSrc = pModalSrc?.toUpperCase() || "";
  return (
    modalSrc === "UF" ||
    modalSrc === "SALES" ||
    modalSrc === "INTERNET" ||
    modalSrc === "SATELLITE" ||
    modalSrc === "SUPPORT-INTERNET" ||
    modalSrc === "SUPPORT-SATELLITE" ||
    modalSrc === "SERVICES-INTERNET" ||
    modalSrc === "SERVICES-SATELLITE"
  );
};

export const getArePackageQPsValid = (_pkg: string, cmprPkg: string, packages: any) => {
  const isPkgQPValid = true;
  let isCmprPkgQPValid = true;

  // if(pkg){
  //   let updatedPkg = pkg;
  //   if (pkg?.toLowerCase() === 'choice' ) {
  //     updatedPkg = 'choice™';
  //   } else if (pkg?.toLowerCase() === 'optimomas') {
  //     updatedPkg = 'óptimo más™';
  //   } else if (pkg?.toLowerCase() === 'premier') {
  //     updatedPkg = 'premier™'
  //   }
  //   if (packages.filter(pkgObj => pkgObj.name.toUpperCase() === updatedPkg.toUpperCase()).length === 0) {
  //     isPkgQPValid = false;
  //   }
  // }
  if(cmprPkg){
    let updatedCmprPkg = cmprPkg;
    if (cmprPkg?.toLowerCase() === 'choice') {
      updatedCmprPkg = 'choice™';
    } else if (cmprPkg?.toLowerCase() === 'optimomas') {
      updatedCmprPkg = 'óptimo más™';
    } else if (cmprPkg?.toLowerCase() === 'premier') {
      updatedCmprPkg = 'premier™'
    }
    if (!packages?.some?.(pkg => pkg?.name?.toUpperCase() === updatedCmprPkg?.toUpperCase())) {
      isCmprPkgQPValid = false;
    }
  }

  return {
    isPkgQPValid,
    isCmprPkgQPValid
  };
}
